
interface ComboWhatsAppButtonProps {
  lang: 'en' | 'ja';
}

export default function ComboWhatsAppButton({ lang }: ComboWhatsAppButtonProps) {
  const handleClick = () => {
    const msg = lang === 'en'
      ? "Hi! I'd like to book the Tokyo Night Combo Experience (Izakaya + Karaoke). Could you share availability?"
      : "こんにちは！Tokyo Night Combo Experience（居酒屋＋カラオケ）の予約をしたいです。空き状況を教えてください。";
    window.open(`https://wa.me/819092895522?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-amber-500 to-pink-500 text-white font-bold rounded-full shadow-2xl hover:shadow-amber-500/40 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
      aria-label={lang === 'en' ? 'Book via WhatsApp' : 'WhatsAppで予約'}
    >
      <i className="ri-whatsapp-line text-2xl"></i>
      <span className="hidden sm:inline">
        {lang === 'en' ? 'Book Now' : '今すぐ予約'}
      </span>
      <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
      <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full"></div>
    </button>
  );
}
